module.exports = __webpack_public_path__ + "static/media/others (1).49839e98.webp";